export enum CategoryType {
  ActiveIngredient = '1',
  BodySystem = '2'
}

const { ActiveIngredient, BodySystem } = CategoryType

const nameMapping = new Map([
  [ActiveIngredient, 'Активное вещество'],
  [BodySystem, 'Система организма']
])

export const CategoryTypeUtils = {
  sortedMembers: [ActiveIngredient, BodySystem],
  getName: (x: CategoryType): string => nameMapping.get(x)!
}
